<template>
    <div class="container-dados-cadastrais">
        <h1>Confirme seus dados cadastrais</h1>
        <p style="margin: 12px 0px">É necessária a confirmação dos dados cadastrais para ser possível efetuar a negociação!</p>
        <form-fields :fields="campos" @update:values="valores = $event"></form-fields>
        <div class="box-buttons">
            <button-default text="Confirmar" @click.native="confirmarDadosCadastrais()"></button-default>
        </div>
    </div>
</template>

<script>
    import ButtonDefault from '../../components/buttons/ButtonDefault.vue';
    import FormFields from '../../components/FormFields.vue'
    import axios from '@/services/axios.js';
    import globalMethods from "@/mixins/globalMethods";
    import { createNamespacedHelpers } from 'vuex';

    const {
        mapMutations: mapMutationsPassosRetornarDividas,
        mapGetters: mapGettersPassosRetornarDividas,
    } = createNamespacedHelpers("passosRetornarDividas");

    export default {
        components: { FormFields, ButtonDefault },

        mixins: [globalMethods],

        data() {
            return {
                campos: [],
                valores: [],
                estados: [
                    { id: 'AC', name: 'Acre', codigo: 'AC' },
                    { id: 'AL', name: 'Alagoas', codigo: 'AL' },
                    { id: 'AP', name: 'Amapá', codigo: 'AP' },
                    { id: 'AM', name: 'Amazonas', codigo: 'AM' },
                    { id: 'BA', name: 'Bahia', codigo: 'BA' },
                    { id: 'CE', name: 'Ceará', codigo: 'CE' },
                    { id: 'DF', name: 'Distrito Federal', codigo: 'DF' },
                    { id: 'ES', name: 'Espírito Santo', codigo: 'ES' },
                    { id: 'GO', name: 'Goiás', codigo: 'GO' },
                    { id: 'MA', name: 'Maranhão', codigo: 'MA' },
                    { id: 'MT', name: 'Mato Grosso', codigo: 'MT' },
                    { id: 'MS', name: 'Mato Grosso do Sul', codigo: 'MS' },
                    { id: 'MG', name: 'Minas Gerais', codigo: 'MG' },
                    { id: 'PA', name: 'Pará', codigo: 'PA' },
                    { id: 'PB', name: 'Paraíba', codigo: 'PB' },
                    { id: 'PR', name: 'Paraná', codigo: 'PR' },
                    { id: 'PE', name: 'Pernambuco', codigo: 'PE' },
                    { id: 'PI', name: 'Piauí', codigo: 'PI' },
                    { id: 'RJ', name: 'Rio de Janeiro', codigo: 'RJ' },
                    { id: 'RN', name: 'Rio Grande do Norte', codigo: 'RN' },
                    { id: 'RS', name: 'Rio Grande do Sul', codigo: 'RS' },
                    { id: 'RO', name: 'Rondônia', codigo: 'RO' },
                    { id: 'RR', name: 'Roraima', codigo: 'RR' },
                    { id: 'SC', name: 'Santa Catarina', codigo: 'SC' },
                    { id: 'SP', name: 'São Paulo', codigo: 'SP' },
                    { id: 'SE', name: 'Sergipe', codigo: 'SE' },
                    { id: 'TO', name: 'Tocantins', codigo: 'TO' },
                ]
            }
        },

        methods: {
            ...mapMutationsPassosRetornarDividas(["SET_MOSTRAR_FORMULARIO_DADOS_CADASTRAIS", "SET_DADOS_CADASTRAIS_CONFIRMADOS"]),

            ...mapGettersPassosRetornarDividas(["getPessoa", "getPesCodigo"]),

            confirmarDadosCadastrais() {
                let camposObrigatoriosQueEstaoVazios = [];
                this.campos.forEach((campo) => {
                    if ((this.valores[campo.variableName] == undefined || this.valores[campo.variableName] == '') && campo.required) {
                        camposObrigatoriosQueEstaoVazios.push(campo.label);
                    }
                });

                if (camposObrigatoriosQueEstaoVazios.length > 0) {
                    this.CHANGE_MESSAGE_MODAL({
                        show: true,
                        title: "Erro",
                        message: `Os campos ${camposObrigatoriosQueEstaoVazios.join(', ')} foram preenchidos de forma incorreta`,
                        styleMessage: "danger"
                    });
                    return;
                }

                axios({
                    method: "POST",

                    url: "api.php",

                    params: {
                        a: "cadastrar",
                        b: "dados_cadastrais",
                        token: "c59509089cf6afeb39d2d0b1124ee6d9"
                    },

                    data: {
                        pes_codigo: this.getPesCodigo(),
                        ...this.valores
                    }
                }).then(resposta => {
                    if (resposta.data.retorno) {
                        this.CHANGE_MESSAGE_MODAL({
                            show: true,
                            title: "Sucesso",
                            message: resposta.data.mensagem,
                            styleMessage: "success",
                        });

                        this.SET_MOSTRAR_FORMULARIO_DADOS_CADASTRAIS(false);
                        this.SET_DADOS_CADASTRAIS_CONFIRMADOS(true);
                    } else {
                        this.CHANGE_MESSAGE_MODAL({
                            show: true,
                            title: "Erro",
                            message: resposta.data.mensagem,
                            styleMessage: "danger",
                        });
                    }
                }).catch(_ => {
                    this.CHANGE_MESSAGE_MODAL({
                        show: true,
                        title: "Erro",
                        message: 'Não foi possível gravar os dados informados',
                        styleMessage: "danger",
                    });
                });
            }
        },

        beforeMount() {
            this.SET_LOADING(false);
            this.SET_LOADING_MESSAGE("");

            const pessoa = this.getPessoa();

            const estado = Object.values(this.estados).filter(estado => estado.id == pessoa.pessoaEndereco.pee_estado)[0].id;

            this.campos.push(...[
                {
                    variableName: "telefone",
                    fieldType: "TextFieldMask",
                    maskFormat: "(##) #####-####",
                    label: "Telefone",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pefFone[0],
                },
                {
                    variableName: "email",
                    fieldType: "TextField",
                    label: "E-mail",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pesEmail,
                },
                {
                    variableName: "endereco",
                    fieldType: "TextField",
                    label: "Endereço",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pessoaEndereco.pee_endereco,
                },
                {
                    variableName: "numero",
                    fieldType: "TextFieldMask",
                    maskFormat: "#####",
                    label: "Número",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pessoaEndereco.pee_numero,
                },
                {
                    variableName: "cep",
                    fieldType: "TextFieldMask",
                    maskFormat: "#####-###",
                    label: "CEP",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pessoaEndereco.pee_cep,
                },
                {
                    variableName: "cidade",
                    fieldType: "TextField",
                    label: "Cidade",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pessoaEndereco.pee_cidade,
                },
                {
                    variableName: "bairro",
                    fieldType: "TextField",
                    label: "Bairro",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: pessoa.pessoaEndereco.pee_bairro,
                },
                {
                    variableName: "estado",
                    fieldType: "SelectField",
                    label: "Estado",
                    options: this.estados,
                    keyName: "name",
                    keyValue: "id",
                    type: "text",
                    cols: "4",
                    required: true,
                    valueField: estado,
                },
                {
                    variableName: "complemento",
                    fieldType: "TextField",
                    label: "Complemento",
                    type: "text",
                    cols: "4",
                    valueField: pessoa.pessoaEndereco.pee_observacao,
                },
            ]);
        }
    }
</script>

<style>
    h1 {
        color: var(--backgroundColor);
        font-family: Montserrat-Bold;
        font-size: 28px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    .container-dados-cadastrais {
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f5f9;
        flex: 1;
        box-sizing: border-box;
    }

    .box-buttons {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .box-buttons * {
        padding-right: 10px;
    }

    @media only screen and (max-width: 768px) {
        .box-buttons {
            flex-direction: column;
        }

        .box-buttons button {
            margin: 5px 0;
        }
    }

    .message-sub {
        color: #5b6987;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: justify;
    }
</style>